module.exports = __webpack_public_path__ + "static/media/qr_example.60c552c6.svg";